import { render, staticRenderFns } from "./ItemStatusList.vue?vue&type=template&id=cc561316&scoped=true&"
import script from "./ItemStatusList.vue?vue&type=script&lang=js&"
export * from "./ItemStatusList.vue?vue&type=script&lang=js&"
import style0 from "./ItemStatusList.vue?vue&type=style&index=0&id=cc561316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc561316",
  null
  
)

export default component.exports